import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchUserList,
  updateUserStatus,
} from "../../slices/user/UserList/thunk";
import { createSelector } from "reselect";
import UserDetails from "./UserDetails";
import CustomPagination from "../../Components/Common/CustomePagination";
import Skeleton from "react-loading-skeleton";

const UserList = () => {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);

  const selectUserListState = (state) => state;
  const userListSelector = createSelector(selectUserListState, (state) => ({
    users: state.UserList.users,
    loading: state.UserList.loading,
    error: state.UserList.error,
    pagination: state.UserList.pagination,
  }));

  const { users, loading, error, pagination } = useSelector(userListSelector);

  const filteredUsers = users;

  const handleToggleStatus = async (userId, currentStatus) => {
    const newStatus = !currentStatus;
    await dispatch(updateUserStatus(userId, newStatus));
  };

  const handleUserRowClick = (userId) => {
    setSelectedUserId(userId);
    setIsUserModalOpen(true);
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 500);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  useEffect(() => {
    const params = {
      pageNo,
      pageSize,
      sortBy: "createdAt",
      sortOrder: "DESC",
      isPagination: 1,
      searchTerm: debouncedSearch.trim(),
    };
    dispatch(fetchUserList(params));
  }, [dispatch, pageNo, pageSize, debouncedSearch]);

  document.title = "Users";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <h4 className="card-title mb-0">User List</h4>
                    <div className="search-box ms-3">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setPageNo(0);
                        }}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                </CardHeader>

                <CardBody className="d-flex flex-column">
                  <div className="flex-grow-1 overflow-auto">
                    <table
                      className="table align-middle table-nowrap"
                      id="customerTable"
                    >
                      <thead className="table-light">
                        <tr>
                          <th>Sr. No</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Start Date</th>
                          <th>End Date</th>
                          <th>Plan Duration</th>
                          <th>Plan Status</th>
                          <th>Dietary Preferences</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading && (
                          <>
                            {[...Array(pageSize)].map((_, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <Skeleton height={15} width={40} />
                                  </div>
                                </td>

                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={80} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={150} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={80} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={60} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={60} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={60} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={60} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={40} />
                                  </div>
                                </td>
                                <td>
                                  <div className="d-flex align-items-start">
                                    <Skeleton height={15} width={30} />
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </>
                        )}

                        {error && (
                          <tr>
                            {/* <td colSpan="7" className="text-center text-danger">
                              {error}
                            </td> */}
                          </tr>
                        )}
                        {!loading && users?.length === 0 && (
                          <tr>
                            <td
                              colSpan="10"
                              className="text-center text-danger"
                            >
                              No users found.
                            </td>
                          </tr>
                        )}

                        {!loading &&
                          filteredUsers?.map((user, index) => {
                            const endDate = user?.subscription?.endDate;

                            const parseDate = (dateStr) => {
                              if (!dateStr) return null;
                              const [day, month, year] = dateStr.split("-");
                              return new Date(`${year}-${month}-${day}`);
                            };

                            const today = new Date();
                            const subscriptionStatus =
                              user?.subscription?.status;
                            const isExpired =
                              subscriptionStatus === "ACTIVE" &&
                              endDate &&
                              parseDate(endDate) < today;

                            return (
                              <tr
                                key={index}
                                onClick={() => handleUserRowClick(user?.id)}
                                style={{
                                  cursor: "pointer",

                                  // backgroundColor: isExpired
                                  //   ? "#f8d7da"
                                  //   : "transparent",
                                  // color: isExpired ? "#842029" : "inherit",
                                }}
                              >
                                <td>{pageNo * pageSize + index + 1}</td>
                                <td>{user?.name}</td>
                                <td>{user?.email || "-"} </td>
                                <td>{user?.mobileNo || "-"}</td>
                                <td>{user?.subscription?.startDate || "-"}</td>
                                <td>{user?.subscription?.endDate || "-"}</td>
                                <td>
                                  {user?.subscription?.planDurationInDays ||
                                    "-"}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${
                                      isExpired ? "bg-danger" : "bg-success"
                                    }`}
                                  >
                                    {user?.subscription?.status}
                                  </span>
                                </td>

                                <td>
                                  {Array.isArray(user?.dietaryPreferences) &&
                                  user?.dietaryPreferences.length > 0
                                    ? user?.dietaryPreferences
                                        .map((dp) => dp?.dietaryPreferencesName)
                                        .join(", ")
                                    : "-"}
                                </td>

                                <td onClick={(e) => e.stopPropagation()}>
                                  <FormGroup switch>
                                    <Input
                                      type="switch"
                                      id={`userActiveSwitch-${user?.id}`}
                                      checked={user?.active}
                                      onChange={() =>
                                        handleToggleStatus(
                                          user?.id,
                                          user?.active
                                        )
                                      }
                                      className={
                                        user?.active
                                          ? "form-check-input bg-success border-success"
                                          : ""
                                      }
                                    />
                                  </FormGroup>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex flex-column">
                    <div className="mt-3" style={{ minHeight: "50px" }}>
                      <CustomPagination
                        currentPage={pagination?.currentPage}
                        totalPages={pagination?.totalPages}
                        onPageChange={(page) => setPageNo(page)}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        setPageNo={setPageNo}
                      />
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {selectedUserId && (
        <UserDetails
          id={selectedUserId}
          isOpen={isUserModalOpen}
          onClose={() => setIsUserModalOpen(false)}
        />
      )}
    </React.Fragment>
  );
};

export default UserList;
